export * from './Filters';
export * from './Page';
export * from './Product';
export * from './Search';
export * from './Sorting';

export const meilisearchPagesIndex = process.env.REACT_APP_MEILISEARCH_PAGES_INDEX || '';
export const meilisearchVariantsIndex = process.env.REACT_APP_MEILISEARCH_VARIANTS_INDEX || '';

export enum MeilisearchAttribute {
    type = 'type',
    id = 'id',
    code = 'code',
    categories = 'categories',
    isNew = 'is_new',
    isSale = 'is_sale',
    stock = 'stock',
    inStock = 'in_stock',
    createdAt = 'created_at',
    // Attributes
    numberOfLightSpots = 'attributes.Aantal lichtpunten',
    numberOfSeats = 'attributes.Aantal zitplaatsen',
    hasRemovableSheet = 'attributes.Afneembare hoes?',
    woodFinish = 'attributes.Afwerking Hout',
    alphabet = 'attributes.Alfabet',
    isAntiAllergy = 'attributes.Anti-allergie?',
    hasArmrests = 'attributes.Armleuningen?',
    armrestHeight = 'attributes.Armleuninghoogte',
    bedding = 'attributes.Bed(dengoed)',
    control = 'attributes.Bediening',
    isBpaFree = 'attributes.BPA-vrij?',
    width = 'attributes.Breedte',
    prescription = 'attributes.Brilsterkte',
    colli = 'attributes.Colli',
    confectionKids = 'attributes.Confectie kids',
    connecting = 'attributes.Connecting',
    hasLid = 'attributes.Deksel?',
    deliveryMax = 'attributes.DeliveryMax',
    deliveryMin = 'attributes.DeliveryMin',
    radius = 'attributes.Diameter',
    depth = 'attributes.Diepte',
    isDimmable = 'attributes.Dimbaar?',
    carryWeight = 'attributes.Draaggewicht', // TODO L5W-866: Implement carryWeight, once available
    isTurnable = 'attributes.Draaibaar?',
    extraKitchen = 'attributes.Extra Keuken',
    fitting = 'attributes.Fitting',
    genre = 'attributes.Genre',
    isSuitedForOutside = 'attributes.Geschikt voor buiten?',
    isSuitedForDryer = 'attributes.Geschikt voor droger?',
    isSuitedForMicrowave = 'attributes.Geschikt voor magnetron?',
    isSuitedForOven = 'attributes.Geschikt voor oven?',
    isSuitedForDishwasher = 'attributes.Geschikt voor vaatwasser?',
    isSuitedForFreezer = 'attributes.Geschikt voor vriezer?',
    isSuitedForWashingMachine = 'attributes.Geschikt voor wasmachine?',
    weight = 'attributes.Gewicht',
    height = 'attributes.Hoogte',
    isHeatResistant = 'attributes.Hittebestendig?',
    isHeightAdjustable = 'attributes.In hoogte verstelbaar?',
    isIncludingLightSource = 'attributes.Inclusief lichtbron?',
    isIncludingList = 'attributes.Inclusief lijst?',
    isIncludingPendulum = 'attributes.Inclusief pendel?',
    volume = 'attributes.Inhoud',
    ipRating = 'attributes.IP-waarde',
    color = 'attributes.Kleur',
    colorOfUnderside = 'attributes.Kleur onderstel',
    colorOfTabletop = 'attributes.Kleur tafelblad',
    colorOfSeat = 'attributes.Kleur zitting',
    ageKids = 'attributes.Leeftijd kids',
    length = 'attributes.Lengte',
    lightDirection = 'attributes.Lichtrichting',
    material = 'attributes.Materiaal',
    materialOfUnderside = 'attributes.Materiaal onderstel',
    materialOfTabletop = 'attributes.Materiaal tafelblad',
    materialOfSeat = 'attributes.Materiaal zitting',
    brand = 'attributes.Merk',
    new = 'attributes.Nieuw',
    origin = 'attributes.Origin',
    isPfasFree = 'attributes.PFAS-vrij?',
    hasVisibleLegs = 'attributes.Pootjes zichtbaar?',
    print = 'attributes.Print',
    sku = 'attributes.Productnummer',
    ranking = 'attributes.Ranking',
    isReversible = 'attributes.Reversible?',
    hasZipper = 'attributes.Ritssluiting?',
    space = 'attributes.Ruimte',
    cord = 'attributes.Snoerlengte',
    isStackable = 'attributes.Stapelbaar?',
    requiresDryCleaning = 'attributes.Stomerij?',
    requiresIroning = 'attributes.Strijkvrij?',
    wattage = 'attributes.Stroomverbruik',
    powerSource = 'attributes.Stroomvoorziening',
    timeDisplay = 'attributes.Tijdweergave',
    isSecondChange = 'attributes.Tweedekansje?',
    typeOfCouch = 'attributes.Type bank',
    typeOfBook = 'attributes.Type boek',
    typeOfRug = 'attributes.Type vloerkleed',
    isRetractable = 'attributes.Uitschuifbaar?',
    shape = 'attributes.Vorm',
    shapeOfTabletop = 'attributes.Vorm tafelblad',
    shapeOfRug = 'attributes.Vorm vloerkleed',
    heatSource = 'attributes.Warmtebron?',
    isWaterResistant = 'attributes.Waterbestendig?',
    isWaterProof = 'attributes.Waterdicht?',
    hasWheels = 'attributes.Wieltjes?',
    seatDepth = 'attributes.Zitdiepte',
    // Leftover, might not be needed
    sizing = 'attributes.XS-XXL',
    isNewAttribute = 'attributes.isNew',
    // Miscellaneous
    price = 'price.price',
    priceDiscount = 'price.discount_difference',
    lists = 'lists.name',
}
